import React from 'react';
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Checkbox,
  Typography,
  Divider,
  Space,
  Popconfirm,
  message,
  Modal,
  Collapse,
} from 'antd';
import CreatedBy from './CreatedBy';
import CreatedAt from './CreatedAt';
import Asset from './Asset';

const { Panel } = Collapse;

const FormDetails = ({ form }) => {
  return (
    <Collapse
      defaultActiveKey={['1']}
      style={{ marginBottom: 24 }}
      expandIconPosition="end"
    >
      <Panel header="Initial Details" key="1">
        <Row gutter={8}>
          <CreatedBy form={form} />
          <CreatedAt />
          <Asset form={form} />
        </Row>
      </Panel>
    </Collapse>
  );
};

export default FormDetails;
